import React, { lazy, Suspense, memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import { AUTH_ROLES, AUTH_USER } from "constants/AuthConstant";
import { updatePermissions } from "store/slices/authSlice";
import subAdminsService from "services/subadminsService";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  useBodyClass(`dir-${direction}`);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  const dispatch = useDispatch();
  const { type, userId, roles } = useSelector((state) => state.auth);
  console.log("111 roles", roles);

  useEffect(() => {
    const fetchSubAdminPermissions = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem(AUTH_USER));
        if (userData?._id) {
          const response = await subAdminsService.getSubAdminById(
            userData?._id
          );
          if (response?.data) {
            if (response.data.permissions) {
              let mappedRoles = {};
              response?.data?.permissions?.forEach(({ key, ...role }) => {
                mappedRoles[key] = role;
              });
              localStorage.setItem(AUTH_ROLES, JSON.stringify(mappedRoles));
              console.log('mapped roles before',response)
              dispatch(
                updatePermissions({ permissions: response.data.permissions })
              );
            }
            // dispatch(
            //   updatePermissions({ permissions: response.data.permissions })
            // );
          }
        }
      } catch (error) {
        console.error("Error fetching sub-admin permissions:", error);
      }
    };

    if (type === "SUB_ADMIN") {
      fetchSubAdminPermissions();
    }
  }, [type, dispatch]);

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <Suspense fallback={<Loading cover="content" />}>
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
